__turbopack_context__.v({
  "root": "TouchSwipe-module-scss-module__fODrlG__root",
});
